// extracted by mini-css-extract-plugin
export default {"highlightedText":"nfEOaJT02T7JxuweLZ5MbQ=="};